import store from '@/store'

/**
 * 权限指令 v-permission
 * 用法：
 *   <button v-permission="'func.customer.create'">创建</button>
 *   <button v-permission="['func.customer.edit', 'func.customer.admin']">编辑</button>
 */
export const permission = {
  mounted(el, binding) {
    const { value } = binding
    
    if (!value) {
      el.parentNode?.removeChild(el)
      return
    }
    
    const hasPermission = Array.isArray(value)
      ? store.getters['auth/hasAnyPermission'](value)
      : store.getters['auth/hasPermission'](value)
    
    if (!hasPermission) {
      el.parentNode?.removeChild(el)
    }
  }
}

/**
 * 菜单权限指令 v-menu-permission
 * 用法：
 *   <div v-menu-permission="'menu.customer.all'">...</div>
 */
export const menuPermission = {
  mounted(el, binding) {
    const { value } = binding
    
    if (!value) {
      el.parentNode?.removeChild(el)
      return
    }
    
    const hasMenuPermission = store.getters['auth/hasMenuPermission'](value)
    
    if (!hasMenuPermission) {
      el.parentNode?.removeChild(el)
    }
  }
}

export default {
  permission,
  menuPermission
}
